import React, { Component } from "react"
import { Card, CardBody, CardTitle, Badge, Button, Container, Row, Col, Alert } from "reactstrap"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import "flatpickr/dist/themes/material_blue.css"
import logo from "../../assets/images/site-logo.png"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { withTranslation } from "react-i18next"
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axios from "axios";
import {
    Label,
    Input,
    InputGroup,
    FormGroup,
    Nav,
    NavItem
} from "reactstrap";
import { act } from "react";
import PhoneInputField from "components/Common/PhoneInput";
class OpenhouseLead extends Component {
    constructor(props) {
        super(props)
        this.state = {
            projectData: '',
            formVisible: true,
            isLoading: true
        }
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        const { contactId } = params;
        axios
            .get(`https://rscoreapi.azurewebsites.net/api/ClientSellerOpenhouse/byguid?openhouseGuid=${contactId}`
            )
            .then((res) => {
                this.setState({ contactData: res.data });
            })
            .catch((error) => {
                console.error("There was an error fetching the data!", error);
            });

    }

    handleSellerOphouseLead = (values, action) => {
        const updateFeature = {
            clientOpenhouseLeadId: values.clientOpenhouseLeadId,
            clientOpenhouseGuid: values.clientOpenhouseLeadId,
            clientOpenhouseId: parseInt(values.clientOpenhouseId),
            agentId: parseInt(values.agentId),
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            mobile: values.mobile,
            preApprovedMortgage: (values.preApprovedMortgage == 'Yes') ? true : false,
            howSoonLookingFor: values.howSoonLookingFor,
            currentlyWorkingWithAgent: (values.currentlyWorkingWithAgent == 'Yes') ? true : false,
            isActive: true
        };

        toast.loading("Please wait...");
        axios.post('https://rscoreapi.azurewebsites.net/api/ClientOpenhouseLead/AddClientOpenhouseLeadQR', updateFeature, {
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': str
            }
        })
            .then(response => {
                toast.dismiss();

                if (response.data.success) {
                    toast.success("Thank you for coming to the open house!");
                    action.resetForm();
                } else {
                    response.data.validationErrors.forEach(error => {
                        toast.error(error);
                    });
                }
                // Handle success
            })
            .catch(error => {
                console.error(error);
                // Handle error
            });
    }
    formatPhoneNumber(phone) {
        if (!phone) return '';
        const cleaned = ('' + phone).replace(/\D/g, '');
        const lastTen = cleaned.slice(-10);
        const match = lastTen.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
        return phone;
    }
    render() {
        const { isLoading, contactData, formVisible, thankYouMessage } = this.state;
        //console.log(projectData);
        return (
            <React.Fragment>

                <MetaTags>
                    <title>Open House | Realty Space</title>
                </MetaTags>
                <ToastContainer autoClose={2000} />
                <div className="headrtop">


                </div>
                <div className="page-content" style={{ paddingTop: 40 }}>

                    <Container fluid>

                        <Row>
                            <Col xl="2"></Col>
                            <Col sm="8" className="text-center ">
                                <h2 style={{ marginBottom: 20 }}>Openhouse Visitor : {contactData?.clientListing?.mlsId}</h2>

                            </Col>
                        </Row>

                        <Row>
                            <Col xl="2"></Col>
                            <Col xl="8">

                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{

                                        clientOpenhouseLeadId: contactData?.clientSellerOpenhouseId,
                                        clientOpenhouseId: contactData?.id,
                                        firstName: (this.state && this.state.firstName) || "",
                                        lastName: (this.state && this.state.lastName) || "",
                                        email: (this.state && this.state.email) || "",
                                        mobile: (this.state && this.state.mobile) || "",
                                        agentId: contactData?.agentId,
                                        preApprovedMortgage: '',
                                        howSoonLookingFor: '',
                                        currentlyWorkingWithAgent: ''


                                    }}
                                    validationSchema={Yup.object().shape({
                                       
                                        firstName: Yup.string().required("This is Required"),
                                        lastName: Yup.string().required("This is Required"),
                                        mobile: Yup.string().required(
                                            "Please enter phone number"
                                        ),
                                        email: Yup.string().email("Must be a valid Email")
                                            .max(255)
                                            .required("Email is required")
                                    })}

                                    onSubmit={this.handleSellerOphouseLead}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >
                                            <Card className="newCard">
                                                <CardBody>
                                                    <Row>
                                                        <Col sm="6">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="firstName">
                                                                    {this.props.t("First Name*")}
                                                                </Label>
                                                                <Field
                                                                    name="firstName"
                                                                    type="text"
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.firstName && touched.firstName
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
                                                                    id="name"
                                                                />
                                                                <ErrorMessage
                                                                    name="firstName"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="lastName">
                                                                    {this.props.t("Last Name*")}
                                                                </Label>
                                                                <Field
                                                                    name="lastName"
                                                                    type="text"
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.lastName && touched.lastName
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
                                                                    id="name"
                                                                />
                                                                <ErrorMessage
                                                                    name="lastName"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>
                                                        </Col>


                                                        <Col sm="6">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="email">
                                                                    {this.props.t("Email*")}
                                                                </Label>
                                                                <Field
                                                                    name="email"
                                                                    type="email"
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.email && touched.email
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
                                                                    id="email"
                                                                />
                                                                <ErrorMessage
                                                                    name="email"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                        <PhoneInputField
                                                            label="Phone"
                                                            name="mobile"
                                                            value={values.mobile}
                                                            setFieldValue={setFieldValue}
                                                            error={errors.mobile}
                                                            touched={touched.mobile}
                                                            country="ca"
                                                            required={true}
                                                            />
                                                          
                                                        </Col>
                                                        <Col sm="4">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="preApprovedMortgage">
                                                                    {this.props.t("Are you pre-approved?")}
                                                                </Label>
                                                                <Field as="select" name="preApprovedMortgage" className="form-control" onChange={handleChange}>
                                                                    <option value="">Select</option>
                                                                    <option value="Yes">Yes</option>
                                                                    <option value="No">No</option>

                                                                </Field>

                                                            </FormGroup>
                                                        </Col>

                                                        <Col sm="4">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="howSoonLookingFor">
                                                                    {this.props.t("How soon are you looking to move?")}
                                                                </Label>
                                                                <Field as="select" name="howSoonLookingFor" className="form-control" onChange={handleChange}>
                                                                    <option value="">Select</option>
                                                                    <option value="As Soon As Possible">As Soon As Possible</option>
                                                                    <option value="In 1 Month">In 1 Month</option>
                                                                    <option value="In 3 Months">In 3 Months</option>
                                                                    <option value="In 6 Months">In 6 Months</option>
                                                                    <option value="After 6 Months">After 6 Months</option>

                                                                </Field>

                                                            </FormGroup>
                                                        </Col>

                                                        <Col sm="4">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="currentlyWorkingWithAgent">
                                                                    {this.props.t("Are you currently working with an agent?")}
                                                                </Label>
                                                                <Field as="select" name="currentlyWorkingWithAgent" className="form-control" onChange={handleChange}>
                                                                    <option value="">Select</option>

                                                                    <option value="Yes">Yes</option>
                                                                    <option value="No">No</option>

                                                                </Field>

                                                            </FormGroup>
                                                        </Col>

                                                        <Col sm="12">
                                                            <h6>By clicking submit below, yo consent to allow us from time to time to contact you about our products and services you requested, as well as other content that may be of interest to you</h6>
                                                        </Col>
                                                        <Col sm="12">
                                                            <button type="submit" className="btn btn-add w-md  mt-27">Submit</button>
                                                        </Col>

                                                    </Row>

                                                </CardBody>
                                            </Card>





                                        </Form>
                                    )}
                                </Formik>

                            </Col>

                        </Row>

                    </Container>
                </div>

            </React.Fragment>
        )
    }
}
OpenhouseLead.propTypes = {
    t: PropTypes.any,
    match: PropTypes.object,



}

const mapStateToProps = ({ Project }) => (
    {

        loading: Project.loading

    })
const mapDispatchToProps = dispatch => ({



});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OpenhouseLead));


